import React from "react";
import { FormField, FormItem, FormLabel, FormControl, FormMessage, FormDescription } from "@/components/ui/form";
import { DateTimePicker } from "@/components/ui/date/DateTimePicker";
import type { Control } from "react-hook-form";
import type { MeetingFormValues } from "../../types/meeting-form";

interface TimeRangeFieldsProps {
  control: Control<MeetingFormValues>;
  isSubmitting: boolean;
  onStartTimeChange: (date: Date | undefined) => void;
}

export const TimeRangeFields: React.FC<TimeRangeFieldsProps> = ({ 
  control, 
  isSubmitting,
  onStartTimeChange
}) => (
  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
    <FormField
      control={control}
      name="start_time"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Start Time</FormLabel>
          <FormControl>
            <DateTimePicker value={field.value} onChange={onStartTimeChange} />
          </FormControl>
          <FormDescription>When does the meeting start?</FormDescription>
          <FormMessage />
        </FormItem>
      )}
    />

    <FormField
      control={control}
      name="end_time"
      render={({ field }) => (
        <FormItem>
          <FormLabel>End Time</FormLabel>
          <FormControl>
            <DateTimePicker value={field.value} onChange={field.onChange} />
          </FormControl>
          <FormDescription>When does the meeting end?</FormDescription>
          <FormMessage />
        </FormItem>
      )}
    />
  </div>
);
